import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import distancing_bigger_than from "static/image/onboarding/distancing_bigger_than.png";
import { BottomNextButtonTmp } from "components/common/BottomNextButtonTmp";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "components/mkt/mktVersionUtils";

export default function Habit_7_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(`/${versionToPathPrefix(version)}-onboarding/habit/13`, {
      replace: true,
    });
  };

  return (
    <Box sx={{ paddingBottom: "150px" }}>
      <Stack spacing={4}>
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"내 삶의 변화를 위한 값진 투자."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "당신이 디스턴싱에 투자할 100일은 앞으로 살아갈 50년 중 1%도 채 되지 않습니다."
            }
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {"단 1%의 시간으로 남은 99%의 삶을 바꿔보세요."}
          </CustomTypography>
        </Stack>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={distancing_bigger_than}
            alt={"onboarding"}
            style={{
              width: "90%",
              maxWidth: "330px",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
